import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Article from '../entities/article'
import Cascader from '../entities/cascader'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';

interface ArticleState extends ListState<Article> {
    editArticle: Article;
    cascaders: any;
    topicCascaders: any;
}
class ArticleModule extends ListModule<ArticleState, any, Article>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Article>(),
        loading: false,
        editArticle: new Article(),
        cascaders: new Array<Cascader>(),
        topicCascaders: new Array<Cascader>(),
    }
    actions = {
        async getAll(context: ActionContext<ArticleState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Article/GetAll', { params: payload.data });
            context.state.loading = false;            
            let page = reponse.data.result as PageResult<Article>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getAllMyselfAndChildren(context: ActionContext<ArticleState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Article/GetAllMyselfAndChildren', { params: payload.data });
            context.state.loading = false;            
            let page = reponse.data.result as PageResult<Article>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },async getAllModerated(context: ActionContext<ArticleState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Article/GetAllModerated', { params: payload.data });
            context.state.loading = false;            
            let page = reponse.data.result as PageResult<Article>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<ArticleState, any>, payload: any) {
            await Ajax.post('/api/services/app/Article/Create', payload.data);
        },
        async update(context: ActionContext<ArticleState, any>, payload: any) {
            await Ajax.put('/api/services/app/Article/Update', payload.data);
        },
        async delete(context: ActionContext<ArticleState, any>, payload: any) {
            await Ajax.delete('/api/services/app/Article/Delete?Id=' + payload.data.id);
        },
        async auditedArticle(context: ActionContext<ArticleState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/services/app/Article/AuditedArticle', payload.data);
            context.state.loading = false;
        },
        async placedTopArticle(context: ActionContext<ArticleState, any>, payload: any) {
            await Ajax.post('/api/services/app/Article/PlacedTopArticle', payload.data);
        },
        async get(context: ActionContext<ArticleState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Article/Get?Id=' + payload.id);
            return reponse.data.result as Article;
        },        
        async getCascader(context: ActionContext<ArticleState, any>, payload: any) {            
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetCascaderList', { params: payload.data });
            context.state.cascaders =  reponse.data.result as Array<Cascader>;
            context.state.loading = false;
        },
        async getTopicCascader(context: ActionContext<ArticleState, any>, payload: any) {            
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MultiLevelCategory/GetCascaderList', { params: payload.data });
            context.state.topicCascaders =  reponse.data.result as Array<Cascader>;
            context.state.loading = false;
        }
    };
    mutations = {
        setCurrentPage(state: ArticleState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ArticleState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: ArticleState, article: Article) {
            state.editArticle = article;
        }
    }
}
const articleModule = new ArticleModule();
export default articleModule;